import { httpGet, httpPost } from "./request/requestApi";
const controllerEndpoint = "support/audit";
export class AuditLogsApi {
    static getAuditLogsData(filter, silent = false) {
        return httpPost(controllerEndpoint + "/" + "getAllLogs", { body: filter, silent: silent });
    }
    static getAuditLogItemData(key) {
        return httpGet(controllerEndpoint + "/" + "getItemDetails/" + key);
    }
    static getRecentLogs(silent = true) { return httpGet(`/support/audit/getRecentLogs`, { silent: silent }); }
}
